import { mutatorAction } from "satcheljs";
import getListViewState from "../selectors/getListViewState";

export const setShouldAutoOpenJumpToMutator: (value: boolean) => void = mutatorAction("setShouldAutoOpenJumpToMutator", (value: boolean): void => {
    const listViewState = getListViewState();
    
    listViewState.shouldAutoOpenJumpTo = value;
});
